<template>
    <div>
        <div class="login-wrap">
            <div class="Loading__bar___21yOt"
                 style="background: rgb(255,255,255); width: 0%;height:2px;transition: width .35s;position: fixed;top:0">
            </div>
            <div class="box">
                <div class="title"><img class="logo" src="../assets/img/spzxlogo.png" alt=""></div>
                <div class="login">已经注册,现在<a href="/login">登录</a></div>
            </div>
            <hr class="hr">
        </div>
        <div class="reg_form">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px">
                <div class="reg_form_title"><span class="edit_icon"></span>基本信息</div>
                <el-form-item label="用户名:" prop="login_name" style="width: 500px;position: relative;">
                    <el-input v-model="ruleForm.login_name" style="width: 300px !important;" class="input-item"></el-input>
                    <el-popover
                            placement="right"
                            :offset="150"
                            width="300"
                            trigger="hover"
                            content="">
                        <div>1. 用户名不支持大小写重复注册。<br>
                            2. 长度限制[3-32],支持中英文。<br>
                            3. 不允许特殊字符</div>
                        <el-button type="text" style="margin-left: 10px;position: absolute;top: 0;right: -34px;" slot="reference"
                                   icon="el-icon-info"></el-button>
                    </el-popover>
                </el-form-item>
                <el-form-item label="密码:" prop="password" style="width: 500px;position: relative;">
                    <el-input v-model="ruleForm.password" show-password></el-input>
                    <el-popover
                            placement="right"
                            :offset="150"
                            width="300"
                            trigger="hover"
                            content="">
                        <div>
                            1. 长度限制[6-32]。<br>
                            2. 必须是大小写字母加数字的组合。<br>
                            3. 允许的密码字符
                        </div>
                        <el-button type="text" style="margin-left: 10px;position: absolute;top: 0;right: -34px;" slot="reference"
                                   icon="el-icon-info"></el-button>
                    </el-popover>
                </el-form-item>
                <el-form-item label="确认密码:" prop="password2" style="width: 500px">
                    <el-input v-model="ruleForm.password2" show-password></el-input>
                </el-form-item>
                <el-form-item label="手机号码:" prop="phone" style="width: 500px">
                    <el-input v-model="ruleForm.phone"></el-input>
                </el-form-item>
                <!--<el-form-item label="手机验证码:" style="width: 300px" required>-->
                    <!--<el-input v-model="ruleForm.vcode" style="width: 200px"></el-input>-->
                    <!--<button type="button">获取验证码</button>-->
                    <!--<div>时间倒计时</div>-->
                <!--</el-form-item>-->

                <div class="reg_form_title"><i class="edit_icon_2"></i>企业信息</div>
                <el-form-item label="公司名称:" prop="b_name" style="width: 500px;position: relative;">
                    <el-input v-model="ruleForm.b_name"></el-input>
                    <el-popover
                            placement="right"
                            :offset="150"
                            width="300"
                            trigger="hover"
                            content="最大64个汉字,须与营业执照一致">
                        <el-button type="text" style="margin-left: 10px;position: absolute;top: 0;right: -34px;" slot="reference"
                                   icon="el-icon-info"></el-button>
                    </el-popover>
                </el-form-item>
                <el-form-item label="公司类型:" prop="b_type" >
                    <el-select v-model="ruleForm.b_type" style="width: 300px;">
                        <el-option :value="1" label="企业"></el-option>
                        <el-option :value="2" label="个体工商户"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="经营模式:" prop="b_model">
                    <el-radio-group v-model="ruleForm.b_model">
                        <el-radio :label="1">生产厂家</el-radio>
                        <el-radio :label="2">经营批发</el-radio>
                        <el-radio :label="3">商业服务</el-radio>
                        <el-radio :label="4">招商代理</el-radio>
                        <el-radio :label="0">其他</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!--<el-form-item label="主营行业:" prop="c_id">-->
                    <!--<el-cascader  v-model="c_id_arr" @change="changeCategory" :options="category"></el-cascader>-->
                <!--</el-form-item>-->
                <el-form-item label="主营行业:" prop="c_id">
                    <el-cascader class="input-item" :options="category" @change="changeCategory" :change-on-select="true" v-model="c_id_arr">
                    </el-cascader>
                </el-form-item>


                <el-form-item label="经营地址:" prop="address">
                    <el-cascader  :options="area" v-model="area_id_arr" @change="changeArea"
                                 @active-item-change="handleItemChange" :props="{value:'k'}">
                    </el-cascader>
                    <br/>
                    <el-input class="city" v-model="ruleForm.address"
                              style="margin-top: 22px"
                              placeholder="请填写详细地址，不要重复填写省/市/区（县）"></el-input>
                </el-form-item>
                <el-form-item label="成立时间:" prop="found_time">
                    <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.found_time"
                                    class="input-item"></el-date-picker>
                </el-form-item>
                <el-form-item label="公司介绍:" prop="detail" style="position: relative;">
                    <el-input type="textarea" size="" :rows="4" v-model="ruleForm.detail" ></el-input>
                    <el-popover
                            placement="right-start"
                            :offset="150"
                            width="300"
                            trigger="hover"
                            content=''

                    >
                    <div>  1.请用中文填写贵公司概况、主管产品、品牌、服务等美容（50-200字）。<br>
                        2. 如果仅填写单纯的产品介绍，将有可能无法通过审核。<br>
                        3. 详细的介绍更容易使买家产生信赖感，仔细的填写将达到事半功倍的效果'</div>
                        <el-button type="text" style="margin-left: 10px;position: absolute;top: 0;right: -34px;" slot="reference"
                                   icon="el-icon-info"></el-button>
                    </el-popover>
                </el-form-item>
                <el-form-item label="营业资质照片:" prop="license_img" style="position: relative;">
                    <el-upload
                            name="image"
                            class="avatar-uploader"
                            action="/index.php/common/Find/upload"
                            :show-file-list="false"
                            :on-success="upload1"
                            :before-upload="beforeAvatarUpload1">
                        <img v-if="ruleForm.license_img" :src="ruleForm.license_img" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon" style="    line-height: 178px !important;"></i>
                        <el-popover
                                placement="right-start"
                                :offset="150"
                                width="300"
                                trigger="hover"
                                content='需本企业真实有效的营业执照原件的彩色扫描件或复印件加盖红色公章的彩色扫描件,二选一即可,各项内容清晰且辨识度高,
                                大小不超过10m,图片格式限定为jpg,png;请注意,营业期限小于半年内的营业资质审核不予通过'>
                            <el-button type="text" style="margin-left: 10px;position: absolute;top: 0;right: -34px;"ov slot="reference"
                                       icon="el-icon-info"></el-button>
                        </el-popover>
                    </el-upload>
                </el-form-item>
                <el-form-item label="社会统一信用代码:" prop="c_credit_code">
                    <el-input v-model="ruleForm.c_credit_code" class="input-item"
                              placeholder="请填写社会统一信用代码"></el-input>
                </el-form-item>
                <el-form-item label="需要企业智能小程序:" prop="no_need_miniprogram">
                    <el-radio-group v-model="ruleForm.no_need_miniprogram">
                        <el-radio :label="0">需要</el-radio>
                        <el-radio :label="1">不需要</el-radio>
                    </el-radio-group>
                    <br/>
                    <el-link href="/outside/xcx20190717.docx" target="_blank" v-show="ruleForm.no_need_miniprogram == 0">请下载《小程序开发运营授权书》盖章后扫描,附在合同pdf中</el-link>
                </el-form-item>
                <el-form-item label="合同图片:" prop="contract_img" style="position: relative;">
                    <el-upload
                            name="file"
                            :limit="1"
                            action="/index.php/common/Upload/word"
                            :show-file-list="true"
                            :on-success="upload2"
                            :before-upload="beforeAvatarUpload2">
                        <el-button size="small" type="primary" style="background-color:#ff6700;border:none;">点击上传</el-button>
                    </el-upload>
                    <el-popover
                            placement="right-start"
                            :offset="150"
                            width="300"
                            trigger="hover"
                            content='合同双方需是TP本身与会员企业,且有双方公章,公章和合同章都可以,非公章均不可以(财务章,发票章等);
                                        各项内容清晰且辨识度高,大小不超过20m,图片格式制定为PDF,务必将多页合同扫描在同一PDF文件中上传'>
                        <el-button type="text" style=" margin-left: 10px;position: absolute;top: 0;right: 447px;" slot="reference"
                                   icon="el-icon-info"></el-button>
                    </el-popover>
                </el-form-item>
                <el-form-item label="公司网址:">
                    <el-input v-model="ruleForm.official_url" class="input-item"
                              placeholder="请填写完整的网址，如：http://www.baidu.com"></el-input>
                </el-form-item>
                <el-form-item label="公司logo:">
                    <el-upload
                            name="image"
                            class="avatar-uploader"
                            action="/index.php/common/Find/upload"
                            :show-file-list="false"
                            :on-success="upload3"
                            :before-upload="beforeAvatarUpload1">
                        <img v-if="ruleForm.logo" :src="ruleForm.logo" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon" style="    line-height: 178px !important;"></i>
                        <div slot="tip" class="el-upload__tip" style="white-space: nowrap">请勿上传营业执照、证书或身份证等作为公司logo,且大小不超过5m的jpg,png,jpeg格式图片，否则将会被删除</div>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')" style="background-color:#ff6700;border:none;">确认注册</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<style>
.logo {
    width: 300px;
    height: 80px;
    background-size: 100%;
}
.login {
    margin-bottom: 10px;
    margin-top: -10px;
    display: flex;
    display: -webkit-box;
    align-items: flex-end;
    -webkit-align-items: flex-end;

}
.login a {
    color: #ff6700;
}
.hr {
    clear: both;
    height:2px;border:none;border-top:2px solid #ff6700;
}
.reg_form {
    margin: 50px 300px;
}
.el-icon-info {
    color: #ff6700;
}
.reg_form_title {
    color:#ff6700;
    font-size: 20px;
    margin-bottom: 50px;
}
.edit_icon {
    display: inline-block;
    height: 20px;
    width: 20px;
    background: url(../assets/img/2.png) no-repeat center;
    margin-bottom: -3px;
    margin-right: 10px;
}
.edit_icon_2 {
    display: inline-block;
    height: 20px;
    width: 20px;
    background: url(../assets/img/3.png) no-repeat center;
    margin-bottom: -3px;
    margin-right: 10px;
}
</style>
<script>
    import "../assets/css/login.css";
    import {mapMutations} from 'vuex'

    export default {
        data: function () {
            return {
                web_site:{
                    hotline:'',email:'',copy_right:'',ipc1:'',ipc2:'',ipc3:''
                },
                ruleForm: {
                    login_name: '',
                    password: '',
                    password2: '',
                    phone: '',
                    vcode: 1234,
                    b_name: '',
                    b_type: '',
                    b_model: '',
                    c_id: '',
                    address: '',
                    found_time: '',
                    detail: '',
                    official_url: '',
                    c_credit_code: '',
                    license_img: '',
                    contract_img: '',
                    logo: '',
                    province_id: '',
                    city_id: '',
                    area_id: '',
                    no_need_miniprogram:1
                },
                category:[],
                area:[],
                c_id_arr: [],
                area_id_arr: [],
                rules: {
                    login_name: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                        { min: 3, max: 32, message: '长度在 3 到 32 个字符', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 6, max: 32, message: '长度在 6 到 32 个字符', trigger: 'blur' }
                    ],
                    password2: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' },
                        { min: 6, max: 32, message: '长度在 6 到 32 个字符', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '请输入电话号码', trigger: 'blur' },
                    ],
                    b_name: [
                        { required: true, message: '请输入公司名称', trigger: 'blur' },
                    ],
                    b_type: [
                        { required: true, message: '请输入公司类型', trigger: 'blur' },
                    ],
                    b_model: [
                        { required: true, message: '请输入经营模式', trigger: 'blur' },
                    ],
                    c_id: [
                        { required: true, message: '请输入主营行业', trigger: 'blur' },
                    ],
                    address: [
                        { required: true, message: '请输入经营地址', trigger: 'blur' },
                    ],
                    found_time: [
                        { required: true, message: '请输入成立日期', trigger: 'blur' },
                    ],
                    detail: [
                        { required: true, message: '请输入公司介绍', trigger: 'blur' },
                    ],
                    license_img: [
                        { required: true, message: '请上传营业资质图片', trigger: 'blur' },
                    ],
                    // contract_img: [
                    //     { required: true, message: '请上传合同图片', trigger: 'blur' },
                    // ],
                    c_credit_code: [
                        { required: true, message: '请输入社会统一信用代码', trigger: 'blur' },
                    ],
                }
            };
        },
        mounted() {
            document.title = '商家注册-首屏好商贸';
            this.reg();
            this.getCategory();
            this.getArea()
        },
        methods: {
            //
            reg(){
                this.$router.push({
                    path: '/reg',
                });
            },
            upload1(response, file, fileList) {
                if(response.error === 0){
                    this.ruleForm.license_img = response.data
                }else{
                    this.$message.error(response.message);
                }
            },
            upload2(response, file, fileList) {
                if(response.error === 0){
                    this.ruleForm.contract_img = response.data
                }else{
                    this.$message.error(response.message);
                }
            },
            upload3(response, file, fileList) {
                if(response.error === 0){
                    this.ruleForm.logo = response.data
                }else{
                    this.$message.error(response.message);
                }
            },
            beforeAvatarUpload1(file) {
                let isJPG = file.type === 'image/jpeg';
                let isPNG = file.type === 'image/png';
                let type =  isJPG || isPNG;
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!type) {
                    this.$message.error('上传图片只能是 JPG或者PNG 格式!');
                }

                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 10MB!');
                }
                return type && isLt2M;
            },
            beforeAvatarUpload2(file) {
                console.log(file)
                let type = file.type === "application/pdf";
                const isLt2M = file.size / 1024 / 1024 < 20;
                if (!type) {
                    this.$message.error('上传只能是 PDF 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传大小不能超过 20MB!');
                }
                return type && isLt2M;
            },
            //
            ...mapMutations('navTabs', [
                'closeAllTab'
            ]),
            getArea(val = [-1]) {
                let that = this
                let len = val.length
                let pid = 0
                if (val[0] !== -1) {
                    pid = len === 1 ? this.area[val[0]].area_id : (len === 2 ? this.area[val[0]].children[val[1]].area_id :
                        this.area[val[0]].children[val[1]].children[val[2]].area_id);
                }
                this.$ajax.get('common/find/area_cascade?pid=' + pid).then(function (res) {
                    if (res.data.error === 0) {
                        if (val[0] === -1) {
                            that.area = res.data.data
                        } else {
                            if (len === 1) {
                                that.area[val[0]].children = res.data.data;
                            }
                            if (len === 2) {
                                that.area[val[0]].children[val[1]].children = res.data.data;
                            }
                            if (len === 3) {
                                that.area[val[0]].children[val[1]].children[val[2]].children = res.data.data;
                            }
                        }
                    }
                })
            },
            handleItemChange(val) {
                this.getArea(val)
            },
            changeArea(val) {
                if (val.length === 1) {
                    this.ruleForm.province_id = this.area[val[0]].area_id;
                } else if (val.length === 2) {
                    this.ruleForm.province_id = this.area[val[0]].area_id;
                    this.ruleForm.city_id = this.area[val[0]].children[val[1]].area_id
                } else {
                    this.ruleForm.province_id = this.area[val[0]].area_id;
                    this.ruleForm.city_id = this.area[val[0]].children[val[1]].area_id
                    this.ruleForm.area_id = this.area[val[0]].children[val[1]].children[val[2]].area_id
                }
            },
            // changeCategory(v) {
            //     this.ruleForm.c_id = v.pop()
            //     console.log(this.category)
            //     console.log(this.ruleForm.c_id)
            // },
            changeCategory(v){
                if(v[1] != undefined && v[1] == 0){
                    this.c_id_arr = [v[0]];
                    this.ruleForm.c_id = v[0];
                    return true;
                }else if(v[2] != undefined && v[2] == 0){
                    this.c_id_arr = [v[0],v[1]];
                    this.ruleForm.c_id = v[1];
                    return true;
                }else{
                    this.c_id_arr = [v[0],v[1],v[2]];
                    this.ruleForm.c_id = v.pop();
                }
            },
            getCategory() {
                let that = this
                this.$ajax.get('common/find/category_cascade').then(function (res) {
                    if (res.data.error === 0) {
                        that.category = res.data.data
                    }
                })
            },
            submitForm(formName) {
                const self = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        self.$ajax
                            .post("/admin/Login/reg", self.ruleForm)
                            .then(function (res) {
                                if (res.data.error === 0) {
                                    self.$message.success('注册成功');
                                    self.closeAllTab();
                                    self.$router.push("/login");
                                } else {
                                    self.$message.error(res.data.message);
                                }
                            })
                            .catch(function (err) {
                                self.$message.error("网络错误！请联系管理员");
                            });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    };
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

</style>


// WEBPACK FOOTER //
// src/views/Reg.vue